import { Component, Inject } from "@angular/core";
import { LicenseService } from "../../../services/LicenseService";
import { MD_DIALOG_DATA, MdDialogRef, MdSnackBar } from "@angular/material";
import { AdalService } from "../../../shared/adal.service";
import { Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AppLoaderService } from "../../../../services/app-loader/app-loader.service";

@Component({
    template:require('./view-lz30-device-history.component.html'),
    styles:[require('./view-lz30-device-history.component.css')],
    selector:'view-lz30-device-history'
})
export class ViewLZ30DeviceHistory{
    userDeviceDisplayDetail;
    SelectedDeviceDetail;
    LZ30DeviceHistory;
    dialogTitle;
    errorMessage='';
    isLoading=false;
    constructor(
        private licenseService:LicenseService,
        private dialogRef:MdDialogRef<ViewLZ30DeviceHistory>,
        private adalService:AdalService,
        private router:Router,
        private formBuilder:FormBuilder,
        private snackBar:MdSnackBar,
        private appLoader:AppLoaderService,
        @Inject(MD_DIALOG_DATA) public dialogData:any,
    ){
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        this.userDeviceDisplayDetail=dialogData.userDeviceDisplayData
        this.SelectedDeviceDetail=dialogData.SelectedDeviceDetail
        this.dialogTitle='View Device History ['+this.SelectedDeviceDetail.DeviceSerialNo+']'
        this.getLZ30DeviceHistory();
    }
    getLZ30DeviceHistory(){
        this.isLoading=true;
        this.licenseService.viewLZ30DeviceHistory(this.SelectedDeviceDetail.LZ30DeviceId,this.SelectedDeviceDetail.LZ30UserDetailId).subscribe((data)=>{
            if(!data.IsError && data.DataObject!=null){
                this.LZ30DeviceHistory=data.DataObject;
            }
            else{
                this.errorMessage=data.Error;
            }
            this.isLoading=false;
        })
    }
    onCancel(){
        this.dialogRef.close(null);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/lz30/view-lz30-device-history/view-lz30-device-history.component.ts